// src/app/shared/product-img-url.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/environment';

@Pipe({
  name: 'productImgUrl',
  standalone: true,
})
export class ProductImgUrlPipe implements PipeTransform {
    /**
     * Transforms a filename into a full assets URL, forcing .jpg extension.
     * @param filename   e.g. "snare01.png" or "snare01"
     * @param folder     optional folder (default: "/img/products")
     */
    transform(filename: string, folder = '/img/products'): string {
        if (!filename) return '';

        // normalize folder
        const base = folder.startsWith('/') ? folder : `/${folder}`;
        const cleanBase = base.replace(/\/+$/, ''); // remove trailing / if any

        // ensure filename has .jpg
        let name = filename.trim().replace(/^\/+/, ''); // remove leading /
        // replace extension or append .jpg if none
        name = name.replace(/\.[^/.]+$/, '.jpg'); // "file.ext" -> "file.jpg"
        if (!/\.[^/.]+$/.test(filename)) name = `${name}.jpg`.replace(/\.jpg\.jpg$/, '.jpg'); // "file" -> "file.jpg"

        return `${environment.ASSETS_HOST}${cleanBase}/${name}`;
    }
}
